import SelfInitComponent from "General/global-js/SelfInitComponent";
import "./footerlinklist.scss";
import { ScrollToTop } from "General/global-js/scrollToTop";
import { CollapsibleLinklist } from "./collapsibleLinklist";
import { SetTabIndex } from "./setTabindex";

class FooterLinkListComponent extends SelfInitComponent {
  constructor(selector) {

    super(selector, { resize: { leading: true, executeImmediate: true, debounce: true, debounceTime: 20 }}); this.resizeDebounce = false;
  }
  init() {
    ScrollToTop.init();
    SetTabIndex();

    this.resize();
  }

  resize() {
    CollapsibleLinklist.init(768);
    SetTabIndex();
  }
}
new FooterLinkListComponent(".footer__linklist");